/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import styled from '@emotion/styled';

import { isInProgress } from '../../utils/challengeUtils';

const ChallengeStatusPill = ({ children, statusId }: Props) => {
  return (
    <StatusPill highlight={isInProgress(statusId)}>
      <StatusIcon highlight={isInProgress(statusId)} />
      <StatusLabel>{children}</StatusLabel>
    </StatusPill>
  );
};

export default ChallengeStatusPill;

interface Props {
  children: any;
  statusId: number;
}

const StatusPill = styled.div(({ theme, highlight }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  borderRadius: 20,
  padding: '3px 5px',
  backgroundColor: highlight ? theme.color.success : theme.color.info
}));

const StatusIcon = glamorous.span(
  ({ highlight, theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 18,
    width: 18,
    backgroundColor: theme.color.white,
    borderRadius: '50%',
    color: highlight ? theme.color.success : theme.color.info,
    fontSize: theme.fontSize.small,
    marginRight: theme.spacing.tiny,
    '$pill.inProgress &': {
      color: theme.color.success
    }
  }),
  'ion-ios-bolt'
);

const StatusLabel = styled.span(({ theme }) => ({
  color: theme.color.white,
  fontSize: theme.fontSize.xtiny,
  fontWeight: theme.fontWeight.demiBold,
  textTransform: 'uppercase'
}));
